export type TokenPurchasePricingMode = "B2C" | "B2B";

export interface TokenPurchaseConfig {
  mode: TokenPurchasePricingMode;
  isB2B: boolean;
  b2bTokenCount: number;
  b2bPriceKzt: number;
}

const DEFAULT_MODE: TokenPurchasePricingMode = "B2C";
const DEFAULT_B2B_TOKEN_COUNT = 55000;
const DEFAULT_B2B_PRICE_KZT = 5900000;

type TokenPurchaseConfigEnv = Partial<
  Record<
    | "NEXT_PUBLIC_TOKEN_PURCHASE_PRICING_MODE"
    | "NEXT_PUBLIC_B2B_TOKEN_COUNT"
    | "NEXT_PUBLIC_B2B_PRICE_KZT",
    string | undefined
  >
>;

const parsePositiveInt = (
  value: string | undefined,
  fallback: number
): number => {
  const parsed = Number.parseInt(value ?? "", 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const parseTokenPurchaseConfig = (
  env: TokenPurchaseConfigEnv
): TokenPurchaseConfig => {
  const normalizedMode = env.NEXT_PUBLIC_TOKEN_PURCHASE_PRICING_MODE?.trim()
    .toUpperCase();
  const mode: TokenPurchasePricingMode =
    normalizedMode === "B2B" || normalizedMode === "B2C"
      ? normalizedMode
      : DEFAULT_MODE;
  const b2bTokenCount = parsePositiveInt(
    env.NEXT_PUBLIC_B2B_TOKEN_COUNT,
    DEFAULT_B2B_TOKEN_COUNT
  );
  const b2bPriceKzt = parsePositiveInt(
    env.NEXT_PUBLIC_B2B_PRICE_KZT,
    DEFAULT_B2B_PRICE_KZT
  );

  return {
    mode,
    isB2B: mode === "B2B",
    b2bTokenCount,
    b2bPriceKzt,
  };
};

export const tokenPurchaseConfig = parseTokenPurchaseConfig({
  NEXT_PUBLIC_TOKEN_PURCHASE_PRICING_MODE:
    process.env.NEXT_PUBLIC_TOKEN_PURCHASE_PRICING_MODE,
  NEXT_PUBLIC_B2B_TOKEN_COUNT: process.env.NEXT_PUBLIC_B2B_TOKEN_COUNT,
  NEXT_PUBLIC_B2B_PRICE_KZT: process.env.NEXT_PUBLIC_B2B_PRICE_KZT,
});
